import React from 'react';
import PropTypes from 'prop-types';
import { arrayMove } from 'react-sortable-hoc';

import isEqual from 'lodash/isEqual';

import Container from './container';
import Item from './item';

const propTypes = {
	children: PropTypes.array.isRequired,
	onSortEnd: PropTypes.func,
	useDragHandle: PropTypes.bool
};

const defaultProps = {
	useDragHandle: false
};

class Order extends  React.Component {
	constructor(props) {
		super(props);

		this.state = {
			items: this.props.children,
			ghostIndex: null,
			useDragHandle: this.props.useDragHandle
		};
	}

	componentWillReceiveProps(nextProps) {
		if (!isEqual(nextProps, this.props)) {
			this.setState({ items: nextProps.children });
		}
	}

	render() {
		return (
			<div className="sortable-order">
				<Container
					items={this.state.items}
					lockAxis="y"
					useDragHandle={this.state.useDragHandle}
					hideSortableGhost={false}
					helperClass={'sortable-order__list-item-wrap--selected'}
					lockToContainerEdges={true}
					ghostItemWrapIndex={this.state.ghostIndex}
					onSortStart={this.onSaveGhostIndex.bind(this)}
					onSortEnd={this.onSortEnd.bind(this)} />
			</div>
		);
	}

	onSaveGhostIndex({index}) {
		this.setState({
			ghostIndex: index
		});
	}

	onSortEnd({oldIndex, newIndex}) {
		this.setState({
			items: arrayMove(this.state.items, oldIndex, newIndex),
			ghostIndex: null
		});

		if (this.props.onSortEnd) {
			const sorted = this.state.items.map((entity, index) => ({
				sortIndex: this.state.items.length - index,
				entityId: entity.props.id
			}));

			this.props.onSortEnd(sorted, oldIndex, newIndex);
		}

	}
}

Order.propTypes = propTypes;
Order.defaultProps = defaultProps;
Order.Item = Item;

export default Order;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/order-list/main.js